import React, { forwardRef } from 'react';
import { Box } from "@mui/material";

import reportslogo from "../../assets/images/reportslogo.png";

import { DefaultCard } from "../../assets/styled-components/card";
import Kpirepairchart from './Kpirepairchart';
import "../../assets/css/reports.css";
import "../../assets/css/assetreport.css";



const Repairreportform = forwardRef((props, ref) => {
  const { reportdata, className, hospitalname, year, setText, text, date, setDate, service } = props;

  const handleText = (field, value) => {
    setDate((prev) => ({ ...prev, [field]: value }));
  };
  function parsePercentage(value) {
    return typeof value === 'string' && value.includes('%')
      ? parseFloat(value.replace('%', ''))
      : parseFloat(value) || 0;
  }


  const data = [
    parsePercentage(reportdata?.perJan),
    parsePercentage(reportdata?.perFeb),
    parsePercentage(reportdata?.perMarch),
    parsePercentage(reportdata?.perApril),
    parsePercentage(reportdata?.perMay),
    parsePercentage(reportdata?.perJune),
    parsePercentage(reportdata?.perJuly),
    parsePercentage(reportdata?.perAugust),
    parsePercentage(reportdata?.perSept),
    parsePercentage(reportdata?.perOct),
    parsePercentage(reportdata?.perNov),
    parsePercentage(reportdata?.perDec)
  ];

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const filteredData = data.filter(value => value > 0);
  const highestResultIndex = data.indexOf(Math.max(...data));
  const highestMonth = months[highestResultIndex];
  const chartData = {
    labels: [
      `Jan-${year}`, `Feb-${year}`, `Mar-${year}`, `Apr-${year}`, `May-${year}`, `Jun-${year}`,
      `Jul-${year}`, `Aug-${year}`, `Sep-${year}`, `Oct-${year}`, `Nov-${year}`, `Dec-${year}`
    ],
    datasets: [
      {
        label: 'Result',
        data: data,
        borderColor: 'rgb(75, 192, 192)',
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        fill: true,
      },
      {
        label: 'Target',
        data: Array(12).fill(100),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        fill: true,
      },
      {
        label: 'Linear (Result)',
        data: calculateLinearTrendline(filteredData),
        borderColor: 'rgba(54, 162, 235, 1)',
        borderDash: [10, 5],
        pointRadius: 0,
        fill: false,
        tension: 0.4,
      }
    ],
  };

  const options = {
    scales: {
      x: {
        type: 'category',
        labels: [
          `Jan-${year}`, `Feb-${year}`, `Mar-${year}`, `Apr-${year}`, `May-${year}`, `Jun-${year}`,
          `Jul-${year}`, `Aug-${year}`, `Sep-${year}`, `Oct-${year}`, `Nov-${year}`, `Dec-${year}`
        ],
        ticks: {
          autoSkip: false,
        },
      },
      y: {
        beginAtZero: true,
        min: -40,
        max: 120,
        ticks: {
          callback: function (value) {

            return `${value}%`;
          },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          title: function (context) {
            const datasetLabel = context[0].dataset.label;
            return `Series: ${datasetLabel}`;
          },
          label: function (context) {
            const pointLabel = context.label || '';
            const value = context.raw || 0;
            const formattedValue = `${value}%`;

            if (context.dataset.label === "Target") {
              return `${pointLabel}, Value: ${formattedValue} - Target Plot`;
            } else if (context.dataset.label === "Result") {
              return `${pointLabel}, Value: ${formattedValue} - Result Plot`;
            }
            return `${pointLabel}, Value: ${formattedValue}`;
          },
        },
      },
    },
  };



  function calculateLinearTrendline(data) {
    const n = data.length;
    const sumX = data.reduce((acc, _, i) => acc + i, 0);
    const sumY = data.reduce((acc, y) => acc + y, 0);
    const sumXY = data.reduce((acc, y, i) => acc + i * y, 0);
    const sumXX = data.reduce((acc, _, i) => acc + i * i, 0);

    const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
    const intercept = (sumY - slope * sumX) / n;


    return data.map((_, i) => slope * i + intercept);
  }




  return (
    <div id="capture" className={className} ref={ref}>
      <header className="kpi-header">
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div className="logo" style={{ marginRight: '16px' }}>
            <img src={reportslogo} alt="logo" style={{ maxWidth: '100px', height: '95px' }} />
          </div>


          <div style={{ flexGrow: 0.5 }}></div>

          <div style={{ textAlign: 'center' }}>
            <p style={{ margin: '0', fontSize: '23px', fontFamily: "Arial Narrow", fontWeight: 'bold' }}>
              {hospitalname?.label}

            </p>
            <p style={{ margin: '0', fontSize: '23px', marginTop: '8px', fontFamily: "Arial Narrow", fontWeight: "bold" }}>
              KEY PERFORMANCE INDICATOR - Repair Time Report
            </p>
          </div>


          <div style={{ flexGrow: 1 }}></div>
        </div>




        <section className="kpi-table" style={{ display: 'table', width: '100%', borderCollapse: 'collapse' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>SERVICE STANDARD</strong></td>
                <td style={{ border: '1px solid grey', padding: '10px', verticalAlign: 'top', width: '75%' }} colspan="3">
                  <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px' }}>
                    {service}
                  </span>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>MEASURABLE ELEMENT</strong></td>
                <td style={{ border: '1px solid grey', padding: '10px', verticalAlign: 'top', width: '75%', backgroundColor: 'turquoise' }} colspan="3">
                  <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px' }}>
                    Repair time - Percentage of Repair / Work Orders completed within 7 working days
                  </span>
                </td>
              </tr>
              <tr>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>Numerator</strong></td>
                <td style={{ border: '1px solid grey', padding: '10px', verticalAlign: 'top', width: '25%' }}>Number of repair/work orders {year === 2026 ? "closed" : "completed"} within 7 working days as scheduled for the month</td>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>Inclusion</strong></td>
                <td style={{ border: '1px solid black', padding: '10px', verticalAlign: 'top', width: '25%' }}>All request for repairs for facilities and equipment received and the corresponding number of work orders issued by the maintenance department for each month</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>Denominator</strong></td>
                <td style={{ border: '1px solid grey', padding: '10px', verticalAlign: 'top', width: '25%' }}>Numbers of repair/work orders issued for the month</td>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>Exclusion</strong></td>
                <td style={{ border: '1px solid grey', padding: '10px', verticalAlign: 'top', width: '25%' }}>NA</td>
              </tr>
              <tr>
                <td style={{ border: '1px solid grey', padding: '10px', width: '25%' }}><strong>Target</strong></td>
                <td style={{ border: '1px solid grey', padding: '10px', verticalAlign: 'top', width: '75%', backgroundColor: 'turquoise' }} colspan="3">
                  <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px' }}>
                    7 working days
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <div style={{ display: 'flex', border: '1px solid grey', padding: '10px', width: '100%', backgroundColor: 'limeGreen' }}>
          <div style={{ flex: '1', padding: '10px' }}>
            <strong>RESULTS FOR THE MONTH OF :</strong>
          </div>
          <div style={{ flex: '3', padding: '10px' }}>
            <span style={{ display: 'inline-block', width: '100%', color: 'black', padding: '2px 4px', borderRadius: '4px' }}>
              YTD {highestMonth} {year}
            </span>
          </div>
        </div>


      </header>




      <section className="results-table">
        <table>
          <thead>
            <tr>
              <th>year</th>
              <th>Month</th>
              <th>Jan-{year}</th>
              <th>Feb-{year}</th>
              <th>Mar-{year}</th>
              <th>Apr-{year}</th>
              <th>May-{year}</th>
              <th>Jun-{year}</th>
              <th>Jul-{year}</th>
              <th>Aug-{year}</th>
              <th>Sep-{year}</th>
              <th>Oct-{year}</th>
              <th>Nov-{year}</th>
              <th>Dec-{year}</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan="4">{year}</td>
              <td>Numerator</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuJan || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuFeb || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuMarch || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuApril || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuMay || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuJune || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuJuly || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuAugust || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuSept || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuOct || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuNov || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuDec || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.nuTotal || "0"}</td>
            </tr>
            <tr>

              <td>Denominator</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deJan || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deFeb || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deMarch || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deApril || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deMay || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deJune || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deJuly || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deAugust || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deSept || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deOct || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deNov || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deDec || "0"}</td>
              <td style={{ textAlign: 'right' }}>{reportdata?.deTotal || "0"}</td>
            </tr>
            <tr className="result-row" style={{ backgroundColor: 'limegreen' }}>
              <td style={{ backgroundColor: 'limegreen', padding: '10px' }}>
                <strong>Result %</strong>
              </td>

              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perJan || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perFeb || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perMarch || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perApril || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perMay || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perJune || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perJuly || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perAugust || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perSept || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perOct || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perNov || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perDec || "0%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{reportdata?.perTotal || "0%"}</strong></td>
            </tr>
            <tr>

              <td ><strong>Target Compliance Rate within 7 days({year === 2025 ? "100%" : "75%"})</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>
              <td style={{ textAlign: 'right' }}><strong>{year === 2025 ? "100%" : "75%"}</strong></td>

            </tr>
          </tbody>
        </table>
      </section>
      <Kpirepairchart chartData={chartData} options={options} />
      <br></br>
      <div style={{ border: 'none', padding: '10px', fontFamily: 'Times New Roman', width: '100%' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>

            <td colSpan="4" style={{ padding: '5px', border: 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>

                <div style={{ border: '2px solid black', flex: '1', width: '100px', height: '220px', flexDirection: 'column', marginRight: '10px' }}>
                  <div style={{ borderBottom: '2px solid black', flexGrow: 1, display: 'flex' }}>
                    <strong style={{ padding: '10px' }}>ANALYSIS</strong>
                  </div>
                  <div style={{ margin: '5px', color: 'black', height: "77%", }}>
                    <textarea
                      style={{
                        outline: 'none',
                        padding: '3px',
                        width: '100%',
                        height: "100%",
                        resize: 'none',
                        overflowWrap: 'break-word',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                        border: 'none',
                      }}
                      value={text.analysis}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setText((prev) => ({
                            ...prev,
                            analysis: e.target.value,
                          }));
                        }
                      }}
                    />
                  </div>
                </div>


                <div style={{ border: '2px solid black', flex: '1', width: '100px', height: '220px', flexDirection: 'column' }}>
                  <div style={{ borderBottom: '2px solid black', flexGrow: 1, display: 'flex' }}>
                    <strong style={{ padding: '10px' }}>IMMEDIATE ACTION TAKEN</strong>
                  </div>
                  <div style={{ margin: '5px', color: 'black', height: "77%", }}>
                    <textarea
                      style={{
                        display: 'block',
                        outline: 'none',
                        padding: '3px',
                        width: '100%',
                        height: "100%",
                        resize: 'none',
                        overflowWrap: 'break-word',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                        border: 'none',
                      }}
                      value={text.immediateAction}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setText((prev) => ({
                            ...prev,
                            immediateAction: e.target.value,
                          }));
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

            </td>


          </tbody>
        </table>
      </div>
      <div style={{ border: 'none', padding: '10px', fontFamily: 'Arial, sans-serif', width: '100%' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>

            <td colSpan="4" style={{ padding: '5px', border: 'none' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                {/* <div style={{ border: '2px solid black', padding: '15px', flex: '1', marginRight: '10px', width: '100px', height: '220px' }}> */}
                <div style={{ border: '2px solid black', flex: '1', width: '100px', height: '220px', flexDirection: 'column', marginRight: '10px' }}>
                  <div style={{ borderBottom: '2px solid black', flexGrow: 1, display: 'flex' }}>
                    <strong style={{ padding: '10px' }}>QUALITY IMPROVEMENT ACTIVITIES</strong>
                  </div>
                  <div style={{ margin: '5px', color: 'black', height: "77%" }}>
                    <textarea
                      style={{
                        outline: 'none',
                        padding: '3px',
                        width: '100%',
                        height: "100%",
                        resize: 'none',
                        overflowWrap: 'break-word',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-wrap',
                        border: 'none',
                      }}
                      value={text.qualityImprovement}
                      onChange={(e) => {
                        if (e.target.value.length <= 500) {
                          setText((prev) => ({
                            ...prev,
                            qualityImprovement: e.target.value,
                          }));
                        }
                      }}
                    />
                  </div>
                </div>


                <div style={{ border: 'none', flex: '1', width: '100px', height: '220px', flexDirection: 'column' }}>

                  <tbody>
                    <tr>




                      <table style={{ width: '100%', height: '220px', borderCollapse: 'collapse', textAlign: 'center', border: '2px solid black', pageBreakInside: 'avoid' }}>
                        <thead>
                          <tr style={{ border: '1px solid black', pageBreakInside: 'avoid' }}>
                            <th style={{ border: '1px solid black', padding: '5px' }}>Prepared by</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>Reviewed by</th>
                            <th style={{ border: '1px solid black', padding: '5px' }}>Approved by</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* <tr style={{ border: '1px solid black', pageBreakInside: 'avoid'  }}>
                                                        <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                            <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                        </td>
                                                        <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                            <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                        </td>
                                                        <td style={{ border: '1px solid black', padding: '5px', height: '40px' }}>
                                                            <input type="text" style={{ border: 'none', outline: 'none', width: '50%', height: '30px' }} />
                                                        </td>
                                                    </tr> */}
                          <tr style={{ border: '1px solid black', pageBreakInside: 'avoid' }}>

                            <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ marginBottom: '5px' }}>
                                  <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                  <input
                                    type="text"
                                    style={{ border: 'none', outline: 'none' }}
                                    value={date.name}
                                    onInput={(e) => handleText("name", e.target.value)}
                                  />
                                </div>
                                <div>
                                  <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                  <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designation} onInput={(e) => handleText("designation", e.target.value)} />
                                </div>
                              </div>
                            </td>
                            <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ marginBottom: '5px' }}>
                                  <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                  <input type="text" style={{ border: 'none', outline: 'none' }} value={date.names}
                                    onInput={(e) => handleText("names", e.target.value)} />
                                </div>
                                <div>
                                  <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                  <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designations} onInput={(e) => handleText("designations", e.target.value)} />
                                </div>
                              </div>
                            </td>
                            <td style={{ border: '1px solid black', padding: '5px', textAlign: 'left' }}>
                              <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <div style={{ marginBottom: '5px', overflow: 'visible' }}>
                                  <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Name:</label>
                                  <input type="text" style={{ border: 'none', outline: 'none' }} value={date.nam} onInput={(e) => handleText("nam", e.target.value)} />
                                </div>
                                <div style={{ marginBottom: '5px', overflow: 'visible' }}>
                                  <label style={{ marginRight: '1px', fontWeight: 'bold', fontSize: '13px' }}>Designation:</label>
                                  <input type="text" style={{ border: 'none', outline: 'none' }} value={date.designatio} onInput={(e) => handleText("designatio", e.target.value)} />
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr style={{ border: "1px solid black" }}>
                            {["date", "dates", "dat"].map((key) => (
                              <td key={key} style={{ border: "1px solid black", padding: "10px", textAlign: "left" }}>
                                <label style={{ marginRight: "3px", fontWeight: "bold", fontSize: "15px" }}>Date:</label>
                                <input
                                  type="text"
                                  style={{ border: "none", outline: "none", width: "50%" }}
                                  value={date[key]}
                                  onChange={(e) => {
                                    let inputValue = e.target.value;

                                    // Allow only numbers and slashes (/), removing any invalid characters
                                    let sanitizedValue = inputValue.replace(/[^0-9/]/g, "");

                                    // Ensure partial valid format (DD/MM/YYYY or partial valid input)
                                    if (/^\d{0,2}\/?\d{0,2}\/?\d{0,4}$/.test(sanitizedValue)) {
                                      handleText(key, sanitizedValue);
                                    }
                                  }}
                                  onBlur={(e) => {
                                    let inputValue = e.target.value;

                                    // Only clear if the input is completely invalid, otherwise keep it
                                    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(inputValue) && inputValue.length > 0) {
                                      handleText(key, inputValue); // Keep input if partially valid
                                    }
                                  }}
                                  maxLength={10}
                                />
                              </td>
                            ))}
                          </tr>

                        </tbody>
                      </table>



                    </tr>
                  </tbody>


                </div>
              </div>

            </td>


          </tbody>
        </table>
      </div>

    </div>

  );
});

export default Repairreportform;
